import { useState } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Ahmad Wahyudi',
      position: 'HRD Manager',
      company: 'PT Konstruksi Jaya',
      image: 'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=1600',
      content:
        'CV Samudera Alam Perkasa telah menjadi mitra yang sangat berharga bagi kami. Mereka selalu menyediakan tenaga kerja berkualitas yang sesuai dengan kebutuhan kami. Profesionalisme dan komunikasi yang baik membuat kerjasama kami berjalan lancar.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Siti Rahayu',
      position: 'Direktur Operasional',
      company: 'PT Industri Manufaktur',
      image: 'https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=1600',
      content:
        'Kami sangat puas dengan layanan manajemen SDM yang diberikan. Tim mereka responsif dan selalu siap membantu kapanpun kami membutuhkan dukungan. Rekomendasi tinggi untuk perusahaan yang membutuhkan solusi tenaga kerja terpadu.',
      rating: 5,
    },
    {
      id: 3,
      name: 'Budi Santoso',
      position: 'CEO',
      company: 'PT Teknologi Terdepan',
      image: 'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=1600',
      content:
        'Bekerja sama dengan CV Samudera Alam Perkasa adalah keputusan terbaik bagi perusahaan kami. Mereka memahami kebutuhan spesifik industri teknologi dan menyediakan talenta yang tepat. Prosesnya efisien dan hasilnya memuaskan.',
      rating: 4,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
            Testimonial Klien
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
            Apa yang dikatakan klien kami tentang layanan yang kami berikan.
          </p>
        </div>

        <div className="max-w-4xl mx-auto relative">
          <div className="relative bg-white rounded-xl shadow-lg p-8 md:p-12">
            <div className="mb-6 flex justify-center">
              <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-primary-100">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            <div className="flex justify-center mb-6">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <Star key={i} size={20} className="text-yellow-500 fill-yellow-500" />
              ))}
            </div>
            
            <blockquote className="text-center text-gray-700 mb-8 italic">
              "{testimonials[currentIndex].content}"
            </blockquote>
            
            <div className="text-center">
              <p className="font-bold text-lg text-navy-900">{testimonials[currentIndex].name}</p>
              <p className="text-primary-600">
                {testimonials[currentIndex].position}, {testimonials[currentIndex].company}
              </p>
            </div>
            
            <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    currentIndex === index ? 'bg-primary-600 w-6' : 'bg-gray-300'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                ></button>
              ))}
            </div>
          </div>
          
          {/* Navigation Buttons */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 bg-white rounded-full p-3 shadow-md hover:bg-gray-100 transition-colors"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={24} className="text-navy-900" />
          </button>
          
          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 bg-white rounded-full p-3 shadow-md hover:bg-gray-100 transition-colors"
            aria-label="Next testimonial"
          >
            <ChevronRight size={24} className="text-navy-900" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;